import { useMutation } from '@apollo/client/react';
import { CREATE_PIPELINE_RUN } from '../queries/CreatePipelineRun';
import { LoggerContextProps } from '../types/LogContext';
import { handleError } from './errorHandler';

export interface CreatePipelineRunProps {
  case_id: string;
  pipeline_type: string;
  documents?: string[];
}

export interface PipelineRun {
  id: string;
  org_id: string;
  case_id: string;
  created_date: string;
  created_by: string;
  pipeline_type: string;
  document_count: number;
  documents: string[];
  status: string;
}

export function useCreatePipelineRun() {
  const context: LoggerContextProps = {
    action: 'createPipelineRun',
  };

  const [createPipelineRunMutation, { data, loading, error }] = useMutation<{
    createPipelineRun: PipelineRun;
  }>(CREATE_PIPELINE_RUN);

  const createPipelineRun = async (input: CreatePipelineRunProps) => {
    try {
      await createPipelineRunMutation({
        variables: { input },
      });
    } catch (error) {
      handleError(error, context, 'Failed to create pipeline run.');
    }
  };

  return { createPipelineRun, data, loading, error };
}
